import { useState } from 'react';
import {
  type RecordRentalPaymentDto,
  type RecordRentalPaymentResponse,
  recordRentalPayment,
} from '../api/rentals';

export interface UseRentalPaymentResult {
  recordPayment: (id: string, dto: RecordRentalPaymentDto) => Promise<RecordRentalPaymentResponse>;
  loading: boolean;
  error: string | null;
}

export function useRentalPaymentWrite(): UseRentalPaymentResult {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const recordPayment = async (
    id: string,
    dto: RecordRentalPaymentDto
  ): Promise<RecordRentalPaymentResponse> => {
    setLoading(true);
    setError(null);
    try {
      const result = await recordRentalPayment(id, dto);
      return result;
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { recordPayment, loading, error };
}
